/** En tête de cellule, ces caractères font lire un texte comme une formule par le tableur. */
const SPREADSHEET_FORMULA_TRIGGERS = /^[=+\-@\t\r]/
/** Nombre formaté FR (éventuellement signé, avec `%`) : légitime, laissé tel quel. */
const SPREADSHEET_FORMATTED_NUMBER = /^[+-]?\d[\d.,\s]*%?$/

/**
 * Neutralise l'injection de formule dans une cellule de tableur (CSV ou XLSX) alimentée par du
 * texte : préfixe une apostrophe si le texte commence par `=`, `+`, `-`, `@`, une tabulation ou un
 * retour chariot, sauf s'il s'agit d'un nombre formaté (`-5`, `+12,5 %`), laissé intact.
 */
export const neutralizeSpreadsheetFormula = (value: string): string =>
  SPREADSHEET_FORMULA_TRIGGERS.test(value) && !SPREADSHEET_FORMATTED_NUMBER.test(value)
    ? `'${value}`
    : value
